export const essentialCookies = i18n => ({
  groupKey: 'ESSENTIAL',
  icon: 'images/cookie-settings/essential-cookies-icon.svg',
  title: i18n.t('cookieSettings.essential.title'),
  description: i18n.t('cookieSettings.essential.description'),
  cookies: [
    {
      name: i18n.t('cookieSettings.essential.authCookie.name'),
      provider: 'sennder GmbH.',
      purpose: i18n.t('cookieSettings.essential.authCookie.purpose'),
      privacyPolicy: 'https://www.sennder.com/privacy-policy'
    },
    {
      name: 'Datadog',
      provider: 'Datadog, Inc.',
      purpose: i18n.t('cookieSettings.essential.datadog.purpose'),
      privacyPolicy: 'https://www.datadoghq.com/legal/privacy/'
    }
  ]
})
